import http from '../../core/services/http'

export const generateOpenTasksReport = ({ taskTypes }) =>
  http.get(`/reports/open-tasks?taskTypes=${taskTypes}`, {
    responseType: 'blob',
  })
